import type { CSSProperties } from "react";

// AI Models sayfasındaki (ModelImagePlaceholder) ile aynı palet — deterministic, title'a bağlı.
const MODEL_GRADIENTS: { from: string; to: string }[] = [
  { from: "#6366f1", to: "#8b5cf6" }, // indigo → violet
  { from: "#3b82f6", to: "#06b6d4" }, // blue → cyan
  { from: "#8b5cf6", to: "#ec4899" }, // violet → pink
  { from: "#0ea5e9", to: "#6366f1" }, // sky → indigo
  { from: "#10b981", to: "#3b82f6" }, // emerald → blue
  { from: "#f59e0b", to: "#ef4444" }, // amber → red
  { from: "#14b8a6", to: "#8b5cf6" }, // teal → violet
  { from: "#ec4899", to: "#f97316" }, // pink → orange
  { from: "#6366f1", to: "#06b6d4" }, // indigo → cyan
  { from: "#a855f7", to: "#3b82f6" }, // purple → blue
];

export function getModelGradientStyle(title?: string): CSSProperties {
  const safeTitle = title?.trim() || "A";
  const sum = safeTitle
    .split("")
    .reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  const gradient = MODEL_GRADIENTS[sum % MODEL_GRADIENTS.length];
  return {
    background: `linear-gradient(135deg, ${gradient.from} 0%, ${gradient.to} 100%)`,
  };
}

export function getModelInitial(title?: string): string {
  return (title?.trim() || "A").charAt(0).toUpperCase();
}
